import { memo } from "react";
import Hero from "../components/ContactUs/Hero";
import ContactForm from "../components/ContactUs/ContactForm";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useImagePreloader from "../hooks/useImagePreloader";
import LoadingOverlay from "../components/LoadingOverlay";

import contactHeroImage from "/images/Contact/Hero.webp";

const ContactUs = memo(function ContactUs() {
  useDocumentTitle("contact");

  const imagesToLoad = [contactHeroImage];

  const loading = useImagePreloader(imagesToLoad);

  return (
    <>
      {loading && <LoadingOverlay />}
      <main>
        <Hero heroImage={contactHeroImage} />
        <ContactForm />
      </main>
    </>
  );
});

export default ContactUs;
